"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import PaymentResultModal from "@/components/PaymentResultModal";
import { useCreditsContext } from "@/contexts/CreditsContext";
import { trackPurchase, getPurchaseContext } from "@/libs/ga";
import { trackFunnel, getLastToolId } from "@/libs/analytics";

/** Checkout already returns to /dashboard — keep the success/cancel modal here. */
export default function DashboardPaymentReturn() {
  const searchParams = useSearchParams();
  const { refreshCredits } = useCreditsContext();
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    const paymentSuccess = searchParams.get("payment_success");
    if (paymentSuccess !== "true" && paymentSuccess !== "false") return;

    setShowPaymentModal(true);
    if (paymentSuccess === "true") {
      const purchaseContext = getPurchaseContext(true);
      if (purchaseContext && Object.keys(purchaseContext).length > 0) {
        trackFunnel("monetization", "purchase_completed", {
          ...purchaseContext,
          last_tool_id: getLastToolId() || undefined,
          return_url: window.location.href,
          success: true,
        });
        const sessionId = searchParams.get("session_id");
        trackPurchase({
          transaction_id: sessionId || `pfp_${Date.now()}`,
          value: purchaseContext.value || 0,
          currency: "USD",
          purchase_trigger: purchaseContext.purchase_trigger,
          package_type: purchaseContext.package_type,
          credits: purchaseContext.credits,
          items: [
            {
              item_id: purchaseContext.price_id || sessionId || "unknown",
              item_name: purchaseContext.credits
                ? `${purchaseContext.credits} Credits`
                : purchaseContext.package_type || "Purchase",
              item_category: purchaseContext.package_type || "credits",
              quantity: 1,
              price: purchaseContext.value || 0,
            },
          ],
        });
      }
      refreshCredits();
    } else {
      const purchaseContext = getPurchaseContext(true);
      if (purchaseContext && Object.keys(purchaseContext).length > 0) {
        trackFunnel("monetization", "purchase_cancelled", {
          ...purchaseContext,
          return_url: window.location.href,
        });
      }
    }
  }, [searchParams, refreshCredits]);

  if (!showPaymentModal) return null;
  return <PaymentResultModal onClose={() => setShowPaymentModal(false)} />;
}
